module.exports = __webpack_public_path__ + "static/media/profile-photo.b89ecfcf.png";